module.exports = __webpack_public_path__ + "img/gift-image.17e07efe.png";